import { Id } from '../types/id.type'
import { ReviewSeries } from './reviewSeries.model'
import { User } from './user.model'

export class Project {
  id: Id
  name: string
  contactForComplaintEmail?: string
  reviewSeries: ReviewSeries[]
  cslStyle?: string
  isFavorite?: boolean
  users: User[]
  teamId: string

  constructor(data: {
    id: Id
    name: string
    contactForComplaintEmail?: string
    reviewSeries?: {
      order: string
      id: string
      name: string
      projectId: number
      reviews: {
        id: number
        createdAt: Date
        isLocked: boolean
        name: string
      }[]
    }[]
    cslStyle?: string
    isFavorite?: boolean
    users?: User[]
    teamId?: string
  }) {
    this.name = data.name ?? ''
    this.id = data.id
    this.isFavorite = data.isFavorite ?? false
    this.contactForComplaintEmail = data.contactForComplaintEmail ?? ''
    this.reviewSeries = data.reviewSeries ?? []
    this.cslStyle = data.cslStyle
    this.users = data.users ?? []
    this.teamId = data.teamId ?? ''
  }
}
